// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'chevron';

export const Component = () => (
  <path d='m18.63 19.71 5.891-7.855L18.631 4H0l4.885 7.855L0 19.709h18.63Zm4.933-7.855-5.411 6.849H1.485l4.406-6.849L1.485 4.96h16.667l5.411 6.896Z' />
);

export const viewBox = '0 0 25 25';
